<template>
  <div style="border-top: 1px solid;   margin-left: 13px;  margin-right: 13px;  padding-top: 20px;">
    <h3>Diagnose: <b>{{ bestaetigteDiagnose }}</b></h3>
    <h4 v-if="patientIsWoman">Schwanger: <b>{{ patientIsPregnant }}</b></h4>
  </div>
</template>

<script>
import {mapGetters, mapState} from "vuex";
import {calculateAge} from "../../../js/util";

export default {
  name: "UebersichtDiagnoseComponent",
  computed: {
    ...mapGetters('cdss/diagnosestellung', [
      'bestaetigteDiagnose'
    ]),
    ...mapState('cdss/diagnosestellung', {
      patientIsPregnant: state => {
        const preganancyMap = {
          'j': 'Konzeption bzw. Schwangerschaft kann nicht ausgeschlossen werden',
          'n': 'Konzeption bzw. Schwangerschaft kann ausgeschlossen werden'
        }
        return preganancyMap[state.patientIsPregnant];
      }
    }),
    ...mapState('cdss', {
      patientIsWoman: state => {
        const patientAge = calculateAge(state.patient.birthDate) >= 60;
        return state.patient.sex === 'w' && !patientAge;
      }
    })
  },
  methods: {
    updatePatientIsPregnant(value) {
      this.$store.dispatch('cdss/diagnosestellung/updatePatientIsPregnant', value)
    }
  }
}
</script>

<style scoped>
</style>
